// extracted by mini-css-extract-plugin
export var active = "footer-module--active--7f5b9";
export var bottom = "footer-module--bottom--d6602";
export var bottomLinks = "footer-module--bottomLinks--24247";
export var copyright = "footer-module--copyright--e54b7";
export var dHide = "footer-module--dHide--ffa2a";
export var description = "footer-module--description--3badb";
export var footerMenu = "footer-module--footerMenu--0b027";
export var heading = "footer-module--heading--34ef3";
export var icon = "footer-module--icon--43cd1";
export var isExternal = "footer-module--isExternal--95194";
export var item = "footer-module--item--9906c";
export var itemAccordion = "footer-module--itemAccordion--cb9cb";
export var itemFooter = "footer-module--itemFooter--d4ebd";
export var mHide = "footer-module--mHide--995c5";
export var overlay = "footer-module--overlay--13da0";
export var regularList = "footer-module--regularList--e5aa6";
export var root = "footer-module--root--428e0";
export var subMenu = "footer-module--subMenu--8cf08";
export var top = "footer-module--top--00449";